import { Injectable } from '@angular/core'
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as jQuery from 'jquery';
import 'bootstrap-notify';
let $: any = jQuery;
import { v4 as uuid } from 'uuid';
import { Meta, Title } from '@angular/platform-browser';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
@Injectable()
export class GlobalService {
  public SUCCESS_NO = "1";
  public ERROR_NO = "-1";
  public ROWS = 15;
  public UPLOAD_URL: '/supload/hhjjj';
  public mainLeftNav = 'unfolded';
  public EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
  public MOBILE_REGEXP = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
  public PASSWORD_REGEXP = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/; //8 characters1 numeric character
  public UPPERCASE_REGXP = /[A-Z]/; // 1 Upper Case
  public NUMBER_REGXP = /[0-9]/; // 1 Number
  public SPECIALA_REGXP = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;; // 1 Special
  public SITEID = "37e277ac-9a11-37bd-9acf-30a16135c899";
  public ORGID = "8c04f53a-f6f8-31e9-ad78-ecc334528ef1";
  public DOMAIN_NAME = "bg-restoration.socialretailapps.com"; 
  public PAYU_BASE_URL = "https://test.payu.in";
  //public PAYU_BASE_URL = "https://secure.payu.in";	
/*   public SITEID = "f77f47fe-6a68-3d01-a6dd-091339843d0c";
  public ORGID = "8c04f53a-f6f8-31e9-ad78-ecc334528ef1";
  public DOMAIN_NAME = "rocklandretail.socialretailapps.com"; */
  public PAYU_MERCHANT_KEY = "gtKFFx";//"Bcr7adOH";//"GrRxQaln";//"Bcr7adOH";
  public PAYU_MERCHANT_SALT = "eCwWELxi";//"5wYLs5rpgR";//"vyEyMmdEGK";//"5wYLs5rpgR";
  public SITE_NAME = "Rocklandretail";
  public SITE_URL = "https://mera.shop/";
  public IMAGE_PATH = "http://www.rocklandretail.socialretailapps.com";
  public MOBILE = "+1-732-649-3609";
  public HOST_NAME = "rocklandretail.socialretailapps.com";
  public ORIGIN = 'https://auth.saavha.com';
  public baseAudio: ["https://d23of3eelpcna7.cloudfront.net/"];
  public baseVideo: ["https://d23of3eelpcna7.cloudfront.net/"];
  public COMPONENTS_SMN = "Social Media";
  public COMPONENTS_SB = "Social Business";
  public COMPONENTS_SEC = "Social Ecommerce";
  public SESSION_KEY = this.DOMAIN_NAME.toUpperCase();
  public isLocalStorage = typeof (Storage) !== 'undefined';
  public mfsDomain = "mera.shop"
  public TOKEN = "";
  public SESSION_KEY_VALUE = "";
  public MEMBER_DATA = "";
  public GOOGLE_API = "AIzaSyAxmGxu4VcwxQYR6jGZta2BVDVKHKx4YQU";
  public BUSINESS_WEEKDAY: any = [{ value: 0, label: "Mon" }, { value: 1, label: "Tue" }, { value: 2, label: "Wed" }, { value: 3, label: "Thu" }, { value: 4, label: "Fri" }, { value: 5, label: "Sat" }, { value: 6, label: "Sun" }];
  public BUSINESS_HOURS_START = [{ value: "0000", label: "12:00 am (midnight)" }, { value: "0030", label: "12:30 am" }, { value: "0100", label: "1:00 am" }, { value: "0130", label: "1:30 am" }, { value: "02:00", label: "2:00 am" }, { value: "0230", label: "2:30 am" }, { value: "0300", label: "3:00 am" }, { value: "0330", label: "3:30 am" }, { value: "0400", label: "4:00 am" }, { value: "0430", label: "4:30 am" }, { value: "0500", label: "5:00 am" }, { value: "0530", label: "5:30 am" }, { value: "0600", label: "6:00 am" }, { value: "0630", label: "6:30 am" }, { value: "0700", label: "7:00 am" }, { value: "0730", label: "7:30 am" }, { value: "0800", label: "8:00 am" }, { value: "0830", label: "8:30 am" }, { value: "0900", label: "9:00 am" }, { value: "0930", label: "9:30 am" }, { value: "1000", label: "10:00 am" }, { value: "1030", label: "10:30 am" }, { value: "1100", label: "11:00 am" }, { value: "1130", label: "11:30 am" }, { value: "1200", label: "12:00 pm (noon)" }, { value: "1230", label: "12:30 pm" }, { value: "1300", label: "1:00 pm" }, { value: "1330", label: "1:30 pm" }, { value: "1400", label: "2:00 pm" }, { value: "1430", label: "2:30 pm" }, { value: "1500", label: "3:00 pm" }, { value: "1530", label: "3:30 pm" }, { value: "1600", label: "4:00 pm" }, { value: "1630", label: "4:30 pm" }, { value: "1700", label: "5:00 pm" }, { value: "1730", label: "5:30 pm" }, { value: "1800", label: "6:00 pm" }, { value: "1830", label: "6:30 pm" }, { value: "1900", label: "7:00 pm" }, { value: "1930", label: "7:30 pm" }, { value: "2000", label: "8:00 pm" }, { value: "2030", label: "8:30 pm" }, { value: "2100", label: "9:00 pm" }, { value: "2130", label: "9:30 pm" }, { value: "2200", label: "10:00 pm" }, { value: "2230", label: "10:30 pm" }, { value: "2300", label: "11:00 pm" }, { value: "2330", label: "11:30 pm" }];
  public BUSINESS_HOURS_END = [{ value: "0000", label: "12:00 am (midnight)" }, { value: "0030", label: "12:30 am" }, { value: "0100", label: "1:00 am" }, { value: "0130", label: "1:30 am" }, { value: "02:00", label: "2:00 am" }, { value: "0230", label: "2:30 am" }, { value: "0300", label: "3:00 am" }, { value: "0330", label: "3:30 am" }, { value: "0400", label: "4:00 am" }, { value: "0430", label: "4:30 am" }, { value: "0500", label: "5:00 am" }, { value: "0530", label: "5:30 am" }, { value: "0600", label: "6:00 am" }, { value: "0630", label: "6:30 am" }, { value: "0700", label: "7:00 am" }, { value: "0730", label: "7:30 am" }, { value: "0800", label: "8:00 am" }, { value: "0830", label: "8:30 am" }, { value: "0900", label: "9:00 am" }, { value: "0930", label: "9:30 am" }, { value: "1000", label: "10:00 am" }, { value: "1030", label: "10:30 am" }, { value: "1100", label: "11:00 am" }, { value: "1130", label: "11:30 am" }, { value: "1200", label: "12:00 pm (noon)" }, { value: "1230", label: "12:30 pm" }, { value: "1300", label: "1:00 pm" }, { value: "1330", label: "1:30 pm" }, { value: "1400", label: "2:00 pm" }, { value: "1430", label: "2:30 pm" }, { value: "1500", label: "3:00 pm" }, { value: "1530", label: "3:30 pm" }, { value: "1600", label: "4:00 pm" }, { value: "1630", label: "4:30 pm" }, { value: "1700", label: "5:00 pm" }, { value: "1730", label: "5:30 pm" }, { value: "1800", label: "6:00 pm" }, { value: "1830", label: "6:30 pm" }, { value: "1900", label: "7:00 pm" }, { value: "1930", label: "7:30 pm" }, { value: "2000", label: "8:00 pm" }, { value: "2030", label: "8:30 pm" }, { value: "2100", label: "9:00 pm" }, { value: "2130", label: "9:30 pm" }, { value: "2200", label: "10:00 pm" }, { value: "2230", label: "10:30 pm" }, { value: "2300", label: "11:00 pm" }, { value: "2330", label: "11:30 pm" }];
  public DESCRIPTION = "User Recommendations of Best Restaurants, Shopping, Nightlife, Food, Entertainment, Things to Do, Services and More at " + this.SITE_NAME;
  public SITE_TITLE = " Restaurants, Dentists, Bars, Beauty Salons, Doctors";
public APIDOC=[];
  constructor(private http: HttpClient, private meta: Meta, private metaTitle: Title, private router: Router) {

  }
  randomAlphaNumeric(length) {

    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
    return result;
  }
  public api_doc(a, type) {
    return this.getVal(this.APIDOC, a + '.' + type, '');
  }
  public generateFormGroup(entity,operation){
    let p={};
      let op=this.api_doc(entity,'operations')
      let params=this.getVal(op,operation+'.params',{});
      let removeParam=['orgId','siteId']
      Object.entries(params).forEach(([key, value]) => {
        
     if(_.indexOf(removeParam, key) == -1 ){
      p[key]=[];
     // console.log("if",key);
     }
      });
      return p;
        
  }
  getCarouselImage() {
    return [
      {
        text: "",
        image: "assets/images/home/e1.jpeg"
      },
      {
        text: "",
        image: "assets/images/home/e2.jpeg"
      },
      {
        text: "",
        image: "assets/images/home/e3.jpeg"
      },
      {
        text: "",
        image: "assets/images/home/e4.jpeg"
      },
      {
        text: "",
        image: "assets/images/home/e5.jpeg"
      },
      {
        text: "",
        image: "assets/images/home/e6.jpeg"
      },
      {
        text: "",
        image: "assets/images/home/e7.jpeg"
      },
      {
        text: "",
        image: "assets/images/home/e8.jpeg"
      },
      {
        text: "",
        image: "assets/images/home/e9.jpeg"
      },
      {
        text: "",
        image: "assets/images/home/e10.jpeg"
      }
    ];
  }
  public getRandomUuid() {
    return uuid();
  }
  public mailDraftEmail(obj) {
    let member = [];
    Object.entries(obj.split(",")).forEach(([key, value]) => {
      let uid = this.getRandomUuid();
      let m = {
        display: value,
        id: uid,
        value: uid,
        email: value
      };
      member.push(m);
    });
    return member;
  }
  public shuffle(obj) {
    let ctr = obj.length, temp, index;
    while (ctr > 0) {
      index = Math.floor(Math.random() * ctr);
      ctr--;
      temp = obj[ctr];
      obj[ctr] = obj[index];
      obj[index] = temp;
    }
    return obj;
  }
  public getAppViewParam(path) {
    let o = { id: '', c: '' };
    let a = path.split("-");
    try {
      o.id = atob(a[a.length - 1]);
      o.c = a[a.length - 2];
    } catch (e) {
    }

    return o;
  }
  public getTimelineAppParam(path) {
    let o = { id: '', c: '' };
    let a = path.split("-");
    try {
      o.id = atob(a[a.length - 1]);
      o.c = a[a.length - 3];
      o['a'] = a[a.length - 2];
    } catch (e) {
    }

    return o;
  }
  public showMessage(obj) {

    $.notify({
      message: this.getVal(obj, 'message', '')
    }, {
      type: this.getVal(obj, 'type', 'info')
    });
    //this.toastyService[obj['type']](obj["message"], obj["title"]);
  }
  public addMetaInfo(obj, pageType, key) {
    let site = {
      id: this.SITEID,
      name: this.SITE_NAME
    }
    let description = String(this.getVal(obj, 'description', '')).substring(0, 320);
    if (description == '') {
      description = this.DESCRIPTION;
    }
    description = description.replace(/<[^>]*>/g, '');
    this.metaTitle.setTitle(this.SITE_NAME + ' | ' + this.getVal(obj, key, ''));
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ name: 'keywords', content: this.getVal(obj, 'keyword', '') + ',' });
    this.meta.updateTag({ name: 'title', content: this.SITE_NAME + ' | ' + this.getVal(obj, key, '') });
    this.meta.updateTag({ property: 'og:title', content: this.SITE_NAME + ' - ' + this.getVal(obj, key, '') })
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: "og:site_name", content: this.SITE_NAME });
    if (pageType != 'view') {
      this.meta.updateTag({ property: 'og:image', content: this.SITE_URL + "/cdn/logo/" + this.getVal(site, 'id', '') + "/m/" + this.getVal(site, 'namw', 'noname').replace(/\s/g, "").replace(/[^a-zA-Z0-9]+/g, "-") + "_" + this.getMilliseconds() + ".png" });
    }

    this.meta.updateTag({ property: 'og:price:amount', content: '200' });
    this.meta.updateTag({ property: 'og:price:currency', content: 'USD' });
    this.meta.updateTag({ property: 'og:url', content: this.SITE_URL });


    if (pageType == 'view') {
      this.meta.updateTag({ property: 'og:url', content: this.getVal(obj, 'website_url', this.SITE_URL) });
      // let images = obj.images;
      let images = this.pathToMedia = this.getVal(obj, 'pathToMedia', {});
      Object.entries(images).forEach(([key, value]) => {
        let img = '';
        if (value != undefined) {

          img = this.SITE_URL + "/cdn/photo/" + this.getVal(value, 'uid', '') + "/m/" + this.getVal(obj, key, 'noname').replace(/\s/g, "").replace(/[^a-zA-Z0-9]+/g, "-") + "_" + this.getMilliseconds() + ".png";
        }
        this.meta.addTag({ property: 'og:image', content: img });


      });
      this.meta.updateTag({ name: "twitter:card", content: "summary_large_image" });
      this.meta.updateTag({ name: "twitter:site", content: "@" + this.SITE_NAME });
      this.meta.updateTag({ name: 'twitter:title', content: this.SITE_NAME + ' - ' + this.getVal(obj, key, '') })
      this.meta.updateTag({ name: 'twitter:description', content: description });
      this.meta.updateTag({ name: 'twitter:type', content: 'website' });
      let img = this.SITE_URL + "/cdn/" + obj.application + "/" + this.getVal(obj, 'id', '') + "/m/" + this.getVal(obj, key, 'noname').replace(/\s/g, "").replace(/[^a-zA-Z0-9]+/g, "-") + "_" + this.getMilliseconds() + ".png";
      this.meta.addTag({ name: 'twitter:image', content: img });
      this.meta.updateTag({ name: 'twitter:url', content: this.SITE_URL });
      if (pageType == 'view') {
        this.meta.updateTag({ name: 'twitter:url', content: this.getVal(obj, 'website_url', this.SITE_URL) });
      }

    }
  }
  public getProfileCompletion(obj) {
    var per = 5;
    if (this.getVal(obj, 'firstName', '') != '') {
      per += 5;
    }
    if (this.getVal(obj, 'lastName', '') != '') {
      per += 5;
    }
    if (this.getVal(obj, 'gender', '') != '') {
      per += 5;
    }
    if (this.getVal(obj, 'phone.phone.number', '') != '') {
      per += 10;
    }
    if (this.getVal(obj, 'bio.status', '') != '') {
      per += 10;
    }
    if (this.getVal(obj, 'address', '') != '') {
      per += 10;
    }
    if (this.getVal(obj, 'city', '') != '') {
      per += 10;
    }
    if (this.getVal(obj, 'state', '') != '') {
      per += 10;
    }
    if (this.getVal(obj, 'country', '') != '') {
      per += 10;
    }
    if (this.getVal(obj, 'zip', '') != '') {
      per += 10;
    }


    return per;
  }
  public getCurrency() {
    return this.getVal(this.userSiteDetails(), 'currency', '');
  }
  public getCurrencyIcon() {
    return '<i class="fa fa-' + this.getVal(this.userSiteDetails(), 'currency', '').toLowerCase() + '"></i>';
  }
  public getMilliseconds() {
    return new Date().getTime();
  }
  public isOwner(id) {
    let o = false;
    if (id == this.getSessionVal('id')) {
      o = true;
    }
    return o;
  }
  public generateImagePath(obj, options) {
    let size = (options[3] == undefined) ? 'xs' : options[3];
    return "/cdn/" + options[0] + "/" + this.getVal(obj, options[1], '') + "/" + size + "/" + this.getVal(obj, options[2], 'noname').replace(/\s/g, "").replace(/[^a-zA-Z0-9]+/g, "-") + "_" + this.getMilliseconds() + ".png";
    // return this.IMAGE_PATH + "/cdn/" + options[0] + "/" + this.getVal(obj, options[1], '') + "/" + size + "/" + this.getVal(obj, options[2], 'noname').replace(/\s/g, "").replace(/[^a-zA-Z0-9]+/g, "-") + "_" + this.getMilliseconds() + ".png";
  }
  public removeSpecialChar(str) {
    return str.replace(/[^a-zA-Z0-9]/g, '-').replace(/\s/g, '-');
  }
  public generateParams(obj, delparm) {
    let p = {};
    Object.entries(obj).forEach(([key, value]) => {
      if (!delparm.includes(key)) {
        p[key] = value;
      }
    });
    return p;
  }
  public paramsRemoveNull(obj) {
    for (let key in obj) {
      if (_.isNil(obj[key])) {
        obj[key] = '';
      }
    }
    return obj;
  }
  public pathToMedia(obj) {
    let domina_name = this.getVal(this.userSiteDetails(), 'domainName', '');
    let image_url = "/cdn/" + this.getVal(obj, 'mediaType', '') + "/" + this.getVal(obj, 'id', '') + "/" + this.getVal(obj, 'size', 'xs') + "/" + this.getVal(obj, 'name', 'noname') + "_" + this.getMilliseconds() + ".png";
    return image_url
  }
  public asJsonObject = function (o) {
    let result = {};
    if (typeof o != 'undefined' && typeof o == 'string') {
      try {
        result = JSON.parse(o);
        result
      }
      catch (err) {
        console.log("asJsonObject error", err);
      }
    }

    return result;
  }


  public removeSession() {
    localStorage.removeItem(this.SESSION_KEY);
    this.router.navigate(['']);
  }

  public getSession() {
    if (this.isLocalStorage) {
      let sessionObj = localStorage.getItem(this.SESSION_KEY);
      if (sessionObj !== undefined || sessionObj !== null) {
        let parsedObject = JSON.parse(sessionObj);
        return parsedObject;
      } else {
        //  console.log('GlobalService:getSession sessionObj=null for ', this.SESSION_KEY);
        return null;
      }
    }
    else {
      // console.log('GlobalService:getSession isLocalStorage=null for ', this.SESSION_KEY);
      return null;
    }
  }
  public getComponentKey(c) {
    let o = {
      'Social Ecommerce': 'e',
      'Social Business': 'b',
      'Social Media': 'm',
      'Social Learning': 'l',
      'Social Advertising': 'a'
    };
    return this.getVal(o, c, c);
  }
  public getComponent(c) {
    let o = {
      "e": "Social Ecommerce",
      "b": "Social Business",
      "m": "Social Media",
      "l": "Social Learning",
      "a": "Social Advertising"
    };
    return this.getVal(o, c, c);

  }
  getUploadPathToMedia(o) {
    let name='';
    if(o['file']){
      console.log("inside");
      name = o['file']['uploadedFile']['name'];
   }
    o['filename'] = name;
    o['fileFormat'] = o['filename'].split(".").pop();
    delete o["file"];
    delete o["orgId"];
    delete o["siteId"];
    delete o["cookies"];
    delete o["token"];
    return o;
  }
  getMailUploadPathToMedia(o) {
    let name='';
    if(o['file']){
      name = o['file']['uploadedFile']['name'];
    }
    delete o["file"];
    delete o["orgId"];
    delete o["siteId"];
    delete o["cookies"];
    delete o["token"];
    o['filename'] = name;
    o['entityType'] = o['filename'].split(".").pop();
    return o;
  }
  removePathToMediaImage(obj, id) {
    let a = {}
    Object.entries(obj).forEach(([key, value]) => {
      if (key != id) {
        a[key] = value
      }
    });
    return a;
  }
  public getUploadParams(a, c, mediaType, mediaId) {
    //   
    let p = {
      siteId: this.SITEID,
      orgId: this.ORGID,
      memberId: this.getSessionVal('id'),
      create: true,
      domainName: this.DOMAIN_NAME,
      token: this.getToken(),
      name: this.getSessionVal('firstName') + '_' + this.getMilliseconds(),
      tag: a,
      mediaType: mediaType
    };
    if (!_.isEmpty(mediaId)) {
      p["mediaId"] = mediaId;
    }
    return p;
  }
  public isAuthenticated() {
    if (this.isMember()) {
      return true;
    }
    else {
      return false;
    }
  }

  public getToken() {
    var session = this.getSession();
    var token = "";
    if (session != null) {
      token = session["token"];
    }
    return token;
  }

  public isMember() {
    let session = this.getSession();
    if (session != null) {
      var sessionObject = session[this.SESSION_KEY];
      let role_name = this.getVal(this.userSiteDetails(), 'roleName', '');
      if (sessionObject != null) {
        if (sessionObject['isMember'] && sessionObject['email'] != '' && sessionObject['id'] != '') {
          return true;
        } else if (role_name === "Site Admin" || role_name === "Org Admin") {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        console.log('GlobalService:isMember1=', false);
        return false;
      }
    }
    else {
      console.log('GlobalService:isMember2=', false);
      return false;
    }
  }

  public getMemberData() {
    let session = this.getSession();
    if (session != null) {
      this.MEMBER_DATA = (session[this.SESSION_KEY]) ? session[this.SESSION_KEY] : "";
    } else {
      this.MEMBER_DATA = "";
    }
    return this.MEMBER_DATA;
  }

  public getSessionVal(key) {
    var session = this.getSession();
    var value = '';
    if (session != null) {
      var sessionObject = session[this.SESSION_KEY];
      if (sessionObject != null) {
        value = sessionObject[key];
      }
    }
    return value;
  }

  public userSiteDetails() {
    var session = this.getSession();
    var detailsForSiteId;
    if (session != null) {
      var sessionObject = session[this.SESSION_KEY];
      if (sessionObject != null) {
        var userSiteDetails = sessionObject["userSiteDetails"];
        if (userSiteDetails != null) {
          detailsForSiteId = userSiteDetails[this.SITEID];
        }
      }
    }
    return detailsForSiteId;
  }

  public getVal(o, key, def) {
    if (typeof key == 'undefined' || typeof o == 'undefined') {
      return def;
    }
    else if (typeof def == 'undefined') {
      return '';
    }
    else {
      var temp = o;
      key = String(key).split('.');
      for (var i in key) {
        if (typeof temp[key[i]] == 'undefined') {
          return def;
        }
        else {
          temp = temp[key[i]];
        }
      }
      return temp;
    }
  }
  public paginateInfo(numFound, params) {
    let str = "";
    let row = parseInt(this.getVal(params, 'rows', 0));
    let currentPage = parseInt(this.getVal(params, 'start', 0)) / row;
    //console.log("currentPage",currentPage);
    let page_of = 0;

    if (currentPage > 0) {
      // currentPage=currentPage+1;
      page_of = (currentPage + 1) * row;
      if (page_of >= numFound) {
        page_of = numFound;
      }
      str += '<div id="paginationInfo" class="paginationInfo"> Showing ' + ((currentPage * row) + 1) + ' to ' + page_of + ' of ' + numFound + ' entries </div>';
    } else if (numFound !== 0) {

      if (row >= numFound) {
        page_of = numFound;
      } else {
        page_of = row;
      }
      str += '<div id="paginationInfo" class="paginationInfo"> Showing  1 to ' + page_of + ' of ' + numFound + ' entries </div>';
    }
    return str;
  }
  getAppIcon(app) {
    let a = {'poll':'list-alt', 'register': 'user-plus ', 'login': 'sign-in ', 'page': 'file-text-o', 'product': 'shopping-cart', 'activity': 'history', 'user': 'user', 'chat': 'comments', 'mail': 'envelope', 'photo': 'photo', 'video': 'video-camera', 'audio': 'music', 'event': 'calendar', 'business': 'briefcase', 'blog': 'newspaper-o', 'playList': 'headphones', 'album': 'picture-o', 'channel': 'video-camera', 'friend': 'users', 'logout': 'sign-out' };
    return this.getVal(a, app, '');
  }

} 